import { create } from "zustand";
import { FiltersFormT } from "../app/Yachts/FiltersForm/filters.schema";

export type YachtsStore = {
  filters: FiltersFormT | null;
  setFilters: (filters: FiltersFormT | null) => void;
};

export const useYachtsStore = create<YachtsStore>((set) => ({
  filters: {}, //{ apiStatus: ["synced"] }, TO BE UNCOMMENTED
  setFilters: (filters) => set({ filters }),
}));
